import type { FaireProductEntity } from "../../entity_types/product";

export const p_wwcxm4h8x6: FaireProductEntity = {
  token: "p_wwcxm4h8x6",
  type: "product",
  name: "Honey Hand Cream 1 oz \u2013 Flower Market ",
  brandName: "123 Farm",
  imageUrl:
    "https://cdn.faire.com/fastly/7283d2df4cd151670084f05e1a2d552859a68f3ac3c7a17659316f56dab80d42.jpeg",
  priceDollars: 2,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/a4993b4dbfb17de94b2291d13c4bd5efcd68f0f113ab6456602b31be53db0414.jpeg",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
